// extracted by mini-css-extract-plugin
export var barPlotXAxis = "data-slide-module--barPlotXAxis--383b6";
export var barScatterLegend = "data-slide-module--barScatterLegend--ce0de";
export var barScatterXAxis = "data-slide-module--barScatterXAxis--a7262";
export var barScatterYAxis = "data-slide-module--barScatterYAxis--2a495";
export var columnHeader = "data-slide-module--columnHeader--0e819";
export var gridLine = "data-slide-module--gridLine--77bd9";
export var horizontal = "data-slide-module--horizontal--65433";
export var lineXAxis = "data-slide-module--lineXAxis--c093a";
export var lineYAxis = "data-slide-module--lineYAxis--dc5c9";
export var table = "data-slide-module--table--062e6";
export var title = "data-slide-module--title--a0fd2";
export var titleGraph = "data-slide-module--titleGraph--9ed46";
export var wrapperChart = "data-slide-module--wrapperChart--64586";
export var wrapperHorizontal = "data-slide-module--wrapperHorizontal--a181b";
export var wrapperTable = "data-slide-module--wrapperTable--3f1f5";
export var wrapperVertical = "data-slide-module--wrapperVertical--1d179";